import { render } from "./ReturnSupplierCreateUpdate.vue?vue&type=template&id=76523f76&scoped=true"
import script from "./ReturnSupplierCreateUpdate.vue?vue&type=script&lang=js"
export * from "./ReturnSupplierCreateUpdate.vue?vue&type=script&lang=js"

import "./ReturnSupplierCreateUpdate.vue?vue&type=style&index=0&id=76523f76&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76523f76"]])

export default __exports__